import { ExtendedApartmentBuilding } from '@bpd-library/utilities';

import { useTranslate } from '../../hooks';
import { FormattedStatus } from './status';

/**
 * @description Takes an Extended Apartment building and returns the correct color and translated label.
 * @param {ExtendedApartmentBuilding} apartmentBuilding
 *
 * @return {*}  {(FormattedStatus | undefined)}
 */
const formatApartmentBuildingStatus = (
    apartmentBuilding: ExtendedApartmentBuilding,
): FormattedStatus | undefined => {
    const { status, constructionNumbers, projectPhase } = apartmentBuilding;

    switch (status) {
        case 'InPreparation':
            return {
                label: useTranslate('StatusLabel-InVoorbereiding'),
                color: 'grey',
            };
        case 'SaleSoon':
            return {
                label: useTranslate('SoonOnSale'),
                color: 'grey',
            };
        case 'SaleStarted':
            return {
                label: useTranslate('SalesStarted'),
                color: 'green',
            };
        case 'ForRent':
            return {
                label: useTranslate('Enum-ProjectStatus-InVerhuur'),
                color: 'green',
            };
        case 'Available':
            return {
                label: useTranslate('Enum-ConstructionNumberStatus-Vrij'),
                color: 'green',
            };
        case 'AmountAvailable':
            const availableConstructionNumbers = constructionNumbers!.filter(
                (s) => s.availabilityStatus === 'Available',
            );

            return {
                label: useTranslate('StatusLabel-AmountAvailable', {
                    replace: [{ id: 'Amount', value: `${availableConstructionNumbers.length}` }],
                }),
                color: 'green',
            };
        case 'AssigningOn':
            const allocationDate = new Date(projectPhase?.allocationDate!).toLocaleDateString(
                window.__ENVIRONMENT_DETAILS__.languageIsoCode,
                {
                    day: 'numeric',
                    month: 'short',
                },
            );

            return {
                label: useTranslate('StatusLabel-AssigningOn.Dynamic', {
                    replace: [{ id: 'Date', value: allocationDate }],
                }),
                color: 'orange',
            };
        case 'InOption':
            return {
                label: useTranslate('houses-overview-status-option'),
                color: 'orange',
            };
        case 'Sold':
            return {
                label: useTranslate('houses-overview-status-sold'),
                color: 'red',
            };
        case 'Rented':
            return {
                label: useTranslate('Enum-ProjectStatus-Verhuurd'),
                color: 'red',
            };
        case 'UnderConstruction':
            return {
                label: useTranslate('InhabitedUnderConstruction'),
                color: 'purple',
            };
    }

    return;
};

export { formatApartmentBuildingStatus };
